"use strict";

exports.__esModule = true;
exports.default = cleaner;

function cleaner(id) {
  if (typeof document !== "undefined") {
    const element = document.getElementById(id);

    if (element) {
      element.innerHTML = "";
    }
  }
}